import httpClient from './httpClient';

export const fetchUsers = async () => {
  const { data } = await httpClient.get('/admin/users');
  return data;
};

export const createUser = async (payload) => {
  const { data } = await httpClient.post('/admin/user', payload);
  return data;
};

export const updateUser = async (id, payload) => {
  const { data } = await httpClient.put(`/admin/user/${id}`, payload);
  return data;
};

export const deleteUser = async (id) => {
  await httpClient.delete(`/admin/user/${id}`);
};



